import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { documentationContent } from '../documentationContent';

const SECURITY_DOC_PATH = '/Documentation/7-security.md';

const SecurityDocumentation = () => {
    const securityContent = documentationContent[SECURITY_DOC_PATH];

    return (
        <div>
            {securityContent ? (
                <ReactMarkdown remarkPlugins={[remarkGfm]}>
                    {securityContent}
                </ReactMarkdown>
            ) : (
                <p>Security documentation is not available right now.</p>
            )}
        </div>
    );
};

export default SecurityDocumentation;
